import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { discoveryApi } from '../../api/discovery';
import { homeGuestCandidates, homeServerCandidates } from './homeCandidates';

export function useHomeCandidates(query, homeQuery, { userId, locale, version }) {
  const now = new Date();
  const calendarDay = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const guestFallback = !userId && query.isError && query.data == null;
  const releases = useQuery({
    queryKey: ['web-home-fallback', 'monthly', userId || 'guest', locale, version],
    queryFn: ({ signal }) => discoveryApi.homeMonthlyReleases(signal),
    enabled: guestFallback,
    staleTime: 300000,
    retry: false,
  });
  const waiting = guestFallback && (homeQuery.isPending || releases.isPending);
  const data = useMemo(() => {
    if (query.data != null) return homeServerCandidates(query.data);
    if (!guestFallback || waiting) return undefined;
    return homeGuestCandidates(homeQuery.data, releases.data, new Date(calendarDay));
  }, [query.data, guestFallback, waiting, homeQuery.data, releases.data, calendarDay]);
  return {
    data,
    query: guestFallback
      ? {
          data,
          isPending: waiting,
          isFetching: query.isFetching || releases.isFetching || homeQuery.isFetching,
          isError: releases.isError,
          refetch: () => Promise.all([query.refetch(), releases.refetch(), homeQuery.refetch()]),
        }
      : query,
  };
}
